<template lang="pug">
div.center
  el-col(:span='2').flex
    app-display(label="Nome do Interessado:", :content="processo.nomeRazaoSocialInteressado")
    app-display(label="Número do processo SiCARF:", :content="processo.numeroProcesso")
    app-display(v-if="isCCR", label="Número do título:", :content="numeroTituloDominial")
    app-display(v-if="isCCR", label="Número do processo físico:", :content="numeroProcessoFisico")
  el-col(:span='2').flex
    app-display(label="CPF do Interessado:", :content="processo.cpfCnpjInteressado")
    app-display(label="Tipo de Processo:", :content="processo.tipo.nome || processo.tipo")
    app-display(v-if="isCCR", label="Data de emissão do título:", :content="formatDate(dataEmissaoTituloDominial)")
  el-col(:span='2').right
    app-opcoes-header-analise(
      v-if="showBotaoOpcoesHeader",
      :idProcesso="processo.id",
      :numeroProcesso="processo.numeroProcesso",
      :tipoProcesso="processo.tipo.codigo",
      :statusProcesso="processo.status"
      :protocolo="processo.numeroProtocolo"
      :idDespacho="dadosCadastros.despacho.id"
      :emRetificacao="processo.retificacao"
      :btnPendencia="visualizarBotaoSinalizarPendencia",
      :btnSolicitarInformacao="showSolicitarInformacoes()"
    )
</template>

<script>
import AppOpcoesHeaderAnalise from '@/screens/analise/components/modal/AppOpcoesHeaderAnalise'
import AppDisplay from '@/components/AppDisplay'
import utils from '@/utils/utils'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppDisplay,
    AppOpcoesHeaderAnalise
  },
  props: {
    dadosCadastros: {
      required: true,
      type: Object
    },
    numeroTituloDominial: {
      required: false,
      default: '',
      type: String
    },
    numeroProcessoFisico: {
      required: false,
      default: '',
      type: String
    },
    dataEmissaoTituloDominial: {
      required: false,
      default: '',
      type: String
    },
    processo: {
      required: true
    },
    isCCR: {
      required: true,
      type: Boolean
    },
    showBotaoOpcoesHeader: {
      required: false,
      default: true
    }
  },
  data () {
    return {
      visualizarBotaoSinalizarPendencia: regrasAnalise.visualizarBotaoSinalizarPendencia,
      isAmapa: process.env.ESTADO === 'ap',
      isPara: process.env.ESTADO === 'pa',
      isBahia: process.env.ESTADO === 'ba'
    }
  },
  methods: {
    formatDate (value) {
      return value ? utils.formatDate(value) : '-'
    },
    showSolicitarInformacoes () {
      return this.isBahia
    }
  }
}
</script>
<style lang="scss" scoped>
.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 13%;
}
.flex {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.right {
  align-items: end;
  justify-content: center;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeaderDadosProcesso.vue